export default {
  ["agent_admin"]: `အေဂျင့်အက်ဒမင်`,
  ["edit_pwd"]: `စကားဝှက်ပြင်ဆင်ရန်`,
  ["logout"]: `အကောင့်ထွက်ရန်`,
  ["login"]: `အကောင့်ဝင်ရန်`,
  ["register"]: `မှတ်ပုံတင်ရန်`,
  ["dashboard"]: `ဒက်ရှ်ဘုတ်`,
  ["registration"]: `မှတ်ပုံတင်ခြင်း`,
  ["incomes"]: `ဝင်ငွေများ`,
  ["record"]: `မှတ်တမ်း`,
  ["rules"]: `စည်းမျဉ်းများ`,
  ["account"]: `အကောင့်`,
  ["account_ph"]: `မှန်ကန်သောအကောင့်ကိုထည့်ပါ။`,
  ["password"]: `စကားဝှက်`,
  ["password_ph"]: `မှန်ကန်သောစကားဝှက်ကိုထည့်ပါ။`,
  ["remember_account"]: `ကျွန်ုပ်ကိုမှတ်ထားပါ`,
  ["invite_ratio"]: `ဖိတ်ခေါ်သူများရရှိရန်`,
  ["invite_ratio_desc"]: `အမှန်တကယ်အမြတ်အစွန်းနှင့်ဆုံးရှုံးမှု`,
  ["product_fee_ratio"]: `ကုန်ပစ္စည်းကြွေးများ`,
  ["product_fee_ratio_desc"]: `အမှန်တကယ်အမြတ်အစွန်းနှင့်ဆုံးရှုံးမှု`,
  ["register_count"]: `မှတ်ပုံတင်သူများ`,
  ["login_count"]: `အကောင့်ဝင်သူများ`,
  ["deposit_count"]: `ပွိုင့်များသွင်းသူ`,
  ["first_deposit_count"]: `ပထမအကြိမ်ပွိုင့်များသွင်းသူ`,
  ["deposit_amount"]: `သွင်းငွေ`,
  ["withdraw_amount"]: `ထုတ်ယူငွေ`,
  ["valid_bet_amount"]: `မှန်ကန်သောလောင်းကစား`,
  ["win_amount"]: `အနိုင်ရရှိငွေ`,
  ["bonus_amount"]: `ဘိုနပ်စ်`,
  ["profit_amount"]: `အနိုင်/အရှုံး`,
  ["link_manage"]: `လင့်ခ်စီမံခန့်ခွဲမှု`,
  ["add_link"]: `လင့်ခ်ထည့်ရန်`,
  ["copy_success"]: `ကူးယူမှုအောင်မြင်သည်`,
  ["submit"]: `ပို့လွှတ်ရန်`,
  ["cancel"]: `ပယ်ဖျက်ရန်`,
  ["download"]: `ဒေါင်းလုတ်`,
  ["sub_domain"]: `စားဒိုမိန်း`,
  ["sub_domain_ph"]: `မှန်ကန်သောစားဒိုမိန်းကိုထည့်ပါ။`,
  ["tag_name"]: `တက်ဂ်အမည်`,
  ["tag_name_ph"]: `မှန်ကန်သောတက်ဂ်အမည်ကိုထည့်ပါ။`,
  ["month"]: `လ`,
  ["active_user_count"]: `� actသက်ဝင်လှုပ်ရှားသောအသုံးပြုသူများ`,
  ["product_fee_amount"]: `ကုန်ပစ္စည်းကြွေး`,
  ["dividend_ratio"]: `နှုန်း`,
  ["dividend_amount"]: `ကော်မရှင်`,
  ["status"]: `အခြေအနေ`,
  ["dividend_bill_status_0"]: `ဆက်လက်လုပ်ဆောင်နေသည်`,
  ["dividend_bill_status_4"]: `စောင့်ဆိုင်းနေသည်`,
  ["dividend_bill_status_9"]: `ပေးပြီးသည်`,
  ["month_phase_1"]: `ပထမပိုင်း`,
  ["month_phase_2"]: `ဒုတိယပိုင်း`,
  ["click_here"]: `ဤနေရာကိုနှိပ်ပါ`,
  ["click_here_desc"]: `USDT ထုတ်ယူရန် သင့်အကောင့်မန်နေဂျာကိုဆက်သွယ်ရန်`,
  ["available_commission"]: `ရရှိနိုင်သောကော်မရှင်`,
  ["time"]: `အချိန်`,
  ["affiliate_program"]: `အကယ်ဖီလိတ်ပရိုဂရမ်`,
  ["active_user_desc"]: `တက်ကြွသောအသုံးပြုသူများ- စုစုပေါင်းသွင်းငွေပမာဏ ၃၀၀,၀၀၀ ကျော်သောအသုံးပြုသူဦးရေ`,
  ["payout_instructions"]: `ပေးချေမှုညွှန်ကြားချက်များ`,
  ["payout_instructions_detail"]: `<li>ရှင်းလင်းချက် ၁</li><li>ရှင်းလင်းချက် ၂</li><li>ရှင်းလင်းချက် ၃</li>`,
  ["rules_detail"]: `၁.စည်းမျဉ်း ၁</br>၂.စည်းမျဉ်း ၂</br>၃.စည်းမျဉ်း ၃`,
}
